import { serviceRequest } from './service-request';
import { SessionStorageKeys } from './session-storage-keys';
import { CognitoConfiguration } from '@cognitoforms/utils/clientside-configuration';

/**
 * Reports this page load to the server so the referral cookie is refreshed and marked as belonging to a
 * browser that executes JavaScript. Crawlers never reach this call, so it doubles as the bot filter for
 * the Visit stage of customer journey telemetry. Fires at most once per browser and never throws.
 *
 * The confirmed cookie is what stops the call across sessions; session storage is the within-session
 * backstop for page loads that happen before a confirmation the server already sent reaches this document.
 */
export function reportReferral() {
	if (CognitoConfiguration.ReferrerConfirmed)
		return;

	try {
		if (sessionStorage.getItem(SessionStorageKeys.VisitReported))
			return;

		sessionStorage.setItem(SessionStorageKeys.VisitReported, '1');
	}
	catch (e) { }

	serviceRequest('svc/referrals/report-referral', {
		referringUrl: document.referrer,
		destinationUrl: location.href
	}).catch(() => { });
}

export function getReferringOrganizationName(crs?: string): Promise<{ Name: string | null }> {
	return serviceRequest(
		'svc/referrals/organization-name',
		null,
		{ method: 'GET', query: crs ? { crs } : undefined }
	);
}
